export const getDatesInRange = (startDate, endDate) => {
  const result = [];

  const currentDate = new Date(startDate);
  const endDateTime = new Date(endDate);

  while (currentDate <= endDateTime) {
    const dateString = `${currentDate.getFullYear()}-${(
      currentDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${currentDate.getDate().toString().padStart(2, "0")}`;

    result.push({
      date: currentDate.getDate(),
      month: new Intl.DateTimeFormat("en-US", { month: "short" }).format(
        currentDate
      ),
      year: currentDate.getFullYear(),
      dateId: dateString,
      dateObj: new Date(currentDate),
    });

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return result;
};
